module.exports = __webpack_public_path__ + "img/sport1.634237a6.png";